// Catálogo de mensagens de erro da SPA (namespace ERROS).
//
// Regra do projeto "Mensagens de erro": toda mensagem deve dizer o que aconteceu
// e qual é a próxima ação do usuário. O código de suporte só aparece quando não
// há nada que ele possa fazer sozinho -- mostrá-lo em erro de validação ensina o
// usuário a abrir chamado para problema que ele resolveria em cinco segundos.
//
// Estes textos só aparecem quando o servidor não mandou mensagem própria (ou
// mandou conteúdo técnico, que é descartado). Quando ele manda, vale a dele.
export const Erros = {
  // Títulos usados no modal
  TITULO: {
    VALIDACAO: "Confira os dados informados",
    NEGOCIO: "Não foi possível concluir",
    SESSAO: "Sua sessão expirou",
    PERMISSAO: "Você não tem acesso a este recurso",
    NAO_ENCONTRADO: "Não encontramos o que você procura",
    CONFLITO: "Este registro foi alterado",
    ARQUIVO_GRANDE: "Arquivo muito grande",
    EXCESSO_REQUISICOES: "Muitas tentativas seguidas",
    INDISPONIVEL: "Sistema temporariamente indisponível",
    REDE: "Sem comunicação com o servidor",
    SISTEMICO: "Não foi possível concluir",
  },

  // Corpo da mensagem
  VALIDACAO:
    "Alguns dados não foram aceitos. Revise os campos do formulário e tente novamente.",
  NEGOCIO: "A operação não pôde ser concluída com os dados informados.",
  SESSAO:
    "Faça login novamente para continuar. O que você digitou nesta tela não foi enviado.",
  PERMISSAO:
    "Seu perfil não tem permissão para esta ação. Peça a liberação ao administrador do portal.",
  NAO_ENCONTRADO:
    "O registro não existe mais ou foi removido. Atualize a página e refaça a busca.",
  CONFLITO:
    "Outra pessoa alterou este registro enquanto você editava. Atualize a página para ver a versão mais recente antes de salvar.",
  ARQUIVO_GRANDE:
    "O arquivo excede o tamanho aceito. Envie um arquivo menor.",
  EXCESSO_REQUISICOES:
    "Você fez muitas tentativas em pouco tempo. Aguarde um minuto e tente novamente.",
  INDISPONIVEL:
    "O sistema está temporariamente indisponível. Tente novamente em alguns minutos.",
  REDE:
    "Não conseguimos falar com o servidor. Verifique sua conexão com a internet e tente novamente.",
  SISTEMICO:
    "Ocorreu uma falha inesperada e a equipe técnica foi notificada. Tente novamente em alguns minutos.",

  // Complementos
  CODIGO_SUPORTE: "Código de suporte: {codigo}",
  COM_CODIGO_SUPORTE:
    "Se precisar acionar o suporte, informe o código {codigo}.",

  // Casos específicos de tela
  LOGIN_INVALIDO:
    "Usuário/e-mail ou senha incorretos. Confira os dados e tente novamente.",
  PAGAMENTO_SEM_RESPOSTA:
    "Não recebemos a confirmação do pagamento. Antes de tentar de novo, confira com o estabelecimento ou no aplicativo do seu cartão se a cobrança foi feita, para não pagar duas vezes.",
  LINK_INDISPONIVEL:
    "Não conseguimos carregar este link de pagamento. Confira se o endereço está completo ou peça um novo link ao estabelecimento.",
  CEP_NAO_ENCONTRADO:
    "Não encontramos este CEP. Confira os números ou preencha o endereço manualmente.",
  PERIODO_INVALIDO: "A data final não pode ser anterior à data inicial.",
};
